import axios from "axios";
import ACTIONS from "./types";
import API_ENDPOINTS from "../../configs/API_ENDPOINTS";

// Action describes what changes are needed to be made to the state of your application
// type =  describes the action being made
// payload = represents the data that provides additional information about the action being performed

export const getOrganisationList = () => (dispatch) => {
  const categories = [];

  axios.get(`${API_ENDPOINTS.ORGANIZATIONS}`).then(function (response) {
    response.data.forEach((obj) => {
      if (!categories.some((category) => category.label === obj.name)) {
        categories.push({ value: obj.name, label: obj.name, id: obj._id });
      }
    });
    dispatch({
      type: ACTIONS.MONITORING_MODULE.GET_ORGANISATION_LIST,
      payload: categories, //
    });
  });
};

export const getDeviceNameList = () => (dispatch) => {
  const deviceNames = [];

  axios.get(`${API_ENDPOINTS.DEVICETYPE_CATEGORIES}`).then(function (response) {
    response.data.forEach((obj) => {
      if (!deviceNames.some((name) => name.label === obj.name)) {
        deviceNames.push({ value: obj.name, label: obj.name, id: obj._id });
      }
    });
    dispatch({
      type: ACTIONS.MONITORING_MODULE.GET_DEVICENAME_LIST,
      payload: deviceNames,
    });
  });
};

export const getDeviceModelList = () => (dispatch) => {
  const deviceModels = [];

  axios.get(`${API_ENDPOINTS.DEVICE_MODELS}`).then(function (response) {
    // console.log("Device models", response.data);
    response.data.forEach((obj) => {
      // console.log(obj.title);
      if (!deviceModels.some((model) => model.label === obj.title)) {
        deviceModels.push({ value: obj.title, label: obj.title, id: obj._id });
      }
    });
    dispatch({
      type: ACTIONS.MONITORING_MODULE.GET_DEVICEMODEL_LIST,
      payload: deviceModels,
    });
  });
};

export const getPackages = () => (dispatch) => {
  axios
    .get(`${API_ENDPOINTS.PACKAGES}`)
    .then(function (response) {
      dispatch({
        type: ACTIONS.MONITORING_MODULE.GET_PACKAGES,
        payload: response.data,
      });
    })
    .catch((error) => {
      console.error("Error fetching packages:", error);
    });
};

export const getErrorCodes = () => (dispatch) => {
  axios
    .get(`${API_ENDPOINTS.MONITORING_ERROR_CODES}`)
    .then(function (response) {
      dispatch({
        type: ACTIONS.MONITORING_MODULE.GET_ERROR_CODES,
        payload: response.data,
      });
    })
    .catch((error) => {
      console.error("Error fetching monitoring error codes:", error);
    });
};

export const getStatusCodes = () => (dispatch) => {
  axios
    .get(`${API_ENDPOINTS.MONITORING_STATUS_CODES}`)
    .then(function (response) {
      dispatch({
        type: ACTIONS.MONITORING_MODULE.GET_STATUS_CODES,
        payload: response.data,
      });
    })
    .catch((error) => {
      console.error("Error fetching monitoring error codes:", error);
    });
};
